import React from 'react'
import { Box, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useMutation } from '@apollo/react-hooks'

import { CorporateTypeForm, ICorporateTypeFormValues } from './CorporateTypeForm'
import { UPSERT_CORPORATION_TYPE, GET_CORPORATION_TYPES_BY_ADMIN } from '../../../graphql/queries/businesses'
import { ICorporationType } from '../../../graphql/types/businesses'

interface IProps {
  open: boolean
  corporationType?: ICorporationType | null
  onCancel: () => void
}

export const UpsertCorporateTypeModal: React.FC<IProps> = ({ open, corporationType, onCancel }) => {
  const [error, setError] = React.useState<string | undefined>(undefined)
  const [upsertCorporationType, { loading }] = useMutation(UPSERT_CORPORATION_TYPE, {
    refetchQueries: [
      {
        query: GET_CORPORATION_TYPES_BY_ADMIN,
        variables: {
          pagination: { offset: 0, limit: 15 },
        },
      },
    ],
  })

  const handleSubmit = async (values: ICorporateTypeFormValues) => {
    try {
      await upsertCorporationType({
        variables: {
          input: {
            id: corporationType?.id ?? undefined,
            name: values.name,
          },
        },
      })
      onCancel()
    } catch (error) {
      setError((error as Error).message || 'Произошла ошибка')
    }
  }

  return (
    <Dialog open={open} maxWidth='sm' fullWidth>
      <DialogTitle id='form-dialog-title'>Тип корпорации</DialogTitle>
      <DialogContent>
        {!!error && (
          <Box mb={3}>
            <Alert severity='error'>{error}</Alert>
          </Box>
        )}
        <Box>
          <CorporateTypeForm
            loading={loading}
            corporationType={corporationType}
            onSubmit={handleSubmit}
            onCancel={onCancel}
          />
        </Box>
      </DialogContent>
    </Dialog>
  )
}
